import { realBricksApi } from "../../utils/axiosInterceptors";

export const secondaryMarketPlaceNotificationApi = async (
  data,
  { rejectWithValue }
) => {
  const { signUpForNewsletter, email, onFail = () => {}, onSuccess = () => {} } = data;
  try {
    const response = await realBricksApi.post(
      `/api/v1/user/notify-on-secondary-market${
        email && email !== "" ? `?email=${email}` : ""
      }${
        signUpForNewsletter ? `&signUpForNewsletter=${signUpForNewsletter}` : ""
      }`
    );
    onSuccess()
    return response.data;
  } catch (err) {
    onFail();
    return rejectWithValue(err?.response?.data?.message);
  }
};

export const notifyOnProperty = async (data, { rejectWithValue }) => {
  const {
    propertyId,
    signUpForNewsletter,
    email,
    forSecondary,
    onFail = () => {},
    onSuccess = () => {}
  } = data;
  try {
    const response = await realBricksApi.post(
      `/api/v1/user/notify-on-property?propertyId=${propertyId}${
        signUpForNewsletter ? `&signUpForNewsletter=${signUpForNewsletter}` : ""
      }${
        email && email !== "" ? `&email=${email}` : ""
      }&forSecondary=${forSecondary}`
    );
    onSuccess()
    return response.data;
  } catch (err) {
    onFail();
    return rejectWithValue(err?.response?.data?.message);
  }
};
